<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg5 xl4>
            <v-card>
                <v-toolbar darken color="accent">
                    <v-toolbar-title >
                        Registro
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text @submit.prevent="login">
                    <v-text-field v-model="email" autofocus id="email" color="accent" label="Email" required prepend-icon="mdi-account-circle">
                    </v-text-field>
                    <v-text-field v-model="password" type="password" color="accent" label="Password" required prepend-icon="mdi-lock">
                    </v-text-field>
                    <v-flex class="red--text" v-if="error">
                        {{error}}
                    </v-flex>
                </v-card-text>
                <v-card-actions class="px-3 pb-3">
                    <v-flex text-xs-right>
                        <v-btn @click="register" color="success" :loading="loading">Ingresar</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'register',
  data: function() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    register: function(e) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            // console.log(user);
            alert(`Cuenta creada para  ${firebase.auth().currentUser.email}`);
            this.$router.go({ path: this.$router.path });
          },
          err => {
            alert(err.message);
          }
        );
      e.preventDefault();
    }
  }
};
</script>